/**
 * AI Agent — static UI content (Figma 213:201709 / 201953): the composer's
 * character budget, the greeting-screen suggestion chips, and the chat-search
 * overlay's seed lists. Conversations + messages are live (see `useAiChat`);
 * only these presentational constants remain local.
 */

/** The composer's character budget (Figma: "27/500"). */
export const MAX_CHARS = 500;

/** Greeting-screen quick prompts (Figma 213:201709 chips). */
export const SUGGESTIONS = [
  "What's our conversion rate?",
  "What's our conversion rate?",
  "What's our conversion rate?",
] as const;

/** Chat-search overlay seed lists (Figma 213:202279). */
export const RECENT_SEARCHES = [
  "How do I create a booking?",
  "How does the QR check-in work?",
  "What's the difference between a Booking and an Event?",
] as const;

export const RECENTLY_VISITED = [
  "High-value customer",
  "Bookings",
  "Customers",
  "Repeat customer",
  "Revenue",
  "Leads",
  "Customer satisfaction",
  "VIP customer",
] as const;
